export * from './lib/page-policies.module';
export * from './lib/privacy-policy-dialog/privacy-policy-dialog.component';
export * from './lib/terms-and-conditions-dialog/terms-and-conditions-dialog.component';
